import { IonToast, IonProgressBar, IonImg, useIonViewWillLeave,   IonInfiniteScrollContent, IonInfiniteScroll, IonSpinner, IonRefresherContent, IonRefresher, IonFooter, IonList, IonRippleEffect, IonAvatar, useIonViewWillEnter, IonChip, useIonRouter, IonIcon, IonTextarea, IonGrid, IonRow, IonText, IonCol, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState, useRef, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { createAnimation } from '@ionic/react';
import { checkmarkDoneOutline, checkmarkCircleOutline, closeOutline, sendOutline, chatbubbleEllipses, heart, heartOutline, heartCircle, heartCircleOutline, chatboxOutline } from 'ionicons/icons';

import { showTab, hideTab } from "../components/Tabs";
import NServer, { UIElement, handleRouteError, RegisterAppServices } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import { ContentInfo, ContentInterface, ContentUpdateInt, ItemInfo, CommentInfo, CreateContentInfo, ContentDetail, CountNum } from '../data/item';
import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 
import LikeComp from "../components/LikeComp";
import Comment from "../components/Comment";
import CommentBox from "../components/CommentBox";
import MarketItem from "../components/MarketItem";
import { ContentProp } from "../pages/Content";

import './Main.css'; 
import '../pages/ChatMsg.css'; 



const ContentMarket : React.FC<ContentProp> = ({match}) => {
    const [content, setContent] = useState<ContentInfo>(CreateContentInfo(0, "", "", "/assets/img/avt.jpg"));

    const router = useIonRouter();

    useIonViewWillEnter(() => {
        hideTab();

        RegisterAppServices();
    });

    useIonViewWillLeave(() => {
        showTab();
    });

    // need to refresh
    useEffect(() => {
        setContent(CreateContentInfo(0, "", "", "/assets/img/avt.jpg"));
        getData();
    },[match.params.id]);

    // refresh event
    const doRefresh = async (ev : any) => {
        await getData();
        ev.detail.complete();
    };

    const getData = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.id
        }

        var server = new NServer();
        await server.getList("nc_content_market", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            setContent(server.data.content);
        }
    }

    // update the content
    const onUpdateContent = (index : number, c : any, local : boolean) => {
        if (local)
        {
            // copy content
            let newContent = JSON.parse(JSON.stringify(c));
            setContent(newContent);
        }
        else
        {
            getData();
        }
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/token/market" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonRefresher className="refresher" slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                {
                    content.id < 0 ?
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-text-center" size-md="8" size-lg="6" size-xl="4" size="10">
                            <div><IonText><h4>{ GetStr(LANGUAGE.TXT_CONTENT_404_CAP) }</h4></IonText></div>
                            <div><IonImg className="info-pic" src="/assets/img/empty_pic.png" /></div>
                            <div><IonText>{ GetStr(LANGUAGE.TXT_CONTENT_404_DESC) }</IonText></div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                    :
                <IonGrid className="ion-no-padding full-screen">
                    <IonRow className="full-screen">
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="6" size="12">
                            <MarketItem content={content} index={0} onUpdate={onUpdateContent} view="full" autoplay={match.params.mode != "ad"} />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            }
            </IonContent>
        </IonPage>
    );
};

export default ContentMarket;